export const WEBHOOK_ANALYTICS = {
  "WEBHOOK: Updated": ({ totalUrlCount }: { totalUrlCount: number }) => ({
    webhook_total_count: totalUrlCount,
  }),
  "WEBHOOK: Secret Regenerated": () => ({}),
  "WEBHOOK: Viewed Documentation": () => ({}),
};
